import { useEffect, useState, useLayoutEffect, Suspense } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    TeamsList,
    CurrentTeam,
    titleToKebab,
    toTitleCase
  } from '../../utils'
import { Client, Account, Teams, Functions, ID, Databases } from "appwrite";
import logo from "../../assets/tom-logo-icon-black.jpg"
import { Resend } from 'resend'

import Popup from '../../components/Popup'
import {
    createUser,
    listMembers,
    memberRoles,
    getTeams
} from '../../appwrite/methods'
import DashboardMenu from '../../components/DashboardMenu'
import UserAvatar from '../../components/Avatar';
import Skeleton from '@mui/material/Skeleton';
import { Query } from 'appwrite'
import ThemeOption from '../../components/ThemeOption'

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import { OutlinedCard } from '../../components/OutlinedCard';
import LogoLoader from '../../components/LogoLoader';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import Snackbar from '@mui/material/Snackbar';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Avatar from '@mui/material/Avatar';
import LinearProgress from '@mui/material/LinearProgress';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);
const teams = new Teams(client);
const functions = new Functions(client);
const db = new Databases(client);

var token = null


const columnsMembers = [
    { field: 'id', headerName: 'ID', width: 50 },
    // {
    //     field: 'avatar',
    //     headerName: 'Avatar',
    //     width: 75,
    //     editable: false,
    // },
    {
        field: 'avatar',
        headerName: 'Avatar',
        display: 'flex',
        width: 75,
        renderCell: UserAvatar,
        valueGetter: (value, row) =>
          row.name == null || row.avatar == null
            ? null
            : { name: row.name, color: row.avatar },
        sortable: false,
        filterable: false,
        editable: false
    },
    {
        field: 'name',
        headerName: 'Username',
        width: 150,
        editable: true,
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 250,
        editable: false,
    },
    {
        field: 'roles',
        headerName: 'Roles',
        width: 150,
        renderCell: (params) => params.value.map((role) => <Chip key={role} label={toTitleCase(role)} variant={role === "owner" ? "filled" : "outlined"} sx={{ overflow: 'hidden' }} />),
        valueGetter: (value, row) =>
            row.roles == null
                ? null
                : row.roles,
        editable: true,
    },
    {
        field: 'joined',
        headerName: 'Joined',
        width: 250,
        editable: false,
    },
    // TODO: permissions need to be handled on a per team basis; thus, this functionality should be moved into a different component
    // {
    //     field: 'permissions',
    //     headerName: 'Permissions',
    //     type: 'singleSelect',
    //     valueOptions: ['Admin'],
    //     width: 150,
    //     editable: true,
    // },
    // For info purposes
    // {
    //   field: 'fullName',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
];

const columnsInvites = [
    { field: 'id', headerName: 'ID', width: 50 },
    // {
    //     field: 'avatar',
    //     headerName: 'Avatar',
    //     width: 75,
    //     editable: false,
    // },
    {
        field: 'avatar',
        headerName: 'Avatar',
        display: 'flex',
        width: 75,
        renderCell: UserAvatar,
        valueGetter: (value, row) =>
          row.name == null || row.avatar == null
            ? null
            : { name: row.name, color: row.avatar },
        sortable: false,
        filterable: false,
        editable: false
    },
    {
        field: 'name',
        headerName: 'Username',
        width: 150,
        editable: true,
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 250,
        editable: false,
    },
    {
        field: 'sent',
        headerName: 'Sent Invite',
        width: 250,
        editable: false,
    },
    // TODO: permissions need to be handled on a per team basis; thus, this functionality should be moved into a different component
    // {
    //     field: 'permissions',
    //     headerName: 'Permissions',
    //     type: 'singleSelect',
    //     valueOptions: ['Admin'],
    //     width: 150,
    //     editable: true,
    // },
    // For info purposes
    // {
    //   field: 'fullName',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
];

async function createInvite(teamID, email, roles) {
    token = ID.unique();

    // await account.createMagicURLToken(
    //     ID.unique(),
    //     email,
    //     'http://localhost:5173'
    // )


    // const resend = new Resend('re_123456789');

    // (async function () {
    //     const { data, error } = await resend.emails.send({
    //         from: 'Acme <help@info.automatethat.com>',
    //         to: ['konur@takeoffmonkey.com'],
    //         subject: 'Hello World',
    //         html: '<strong>It works!</strong>',
    //     });

    //     if (error) {
    //         return console.error({ error });
    //     }

    //     console.log({ data });
    // })();

    // Create a new document in the `invites` collection
    db.createDocument(
        teamID,
        'invites',
        token,
        {
            email: email,
            // timestamp: new Date().toISOString().replace("T", " ").replace(/\..+/, ""),
            roles: roles.length < 1 ? ['editor'] : roles.map(string => string.toLowerCase())
        }
    )

    console.log("Email sent");
}


export default function TeamMembers() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [currentTeam, setCurrentTeam] = useAtom(CurrentTeam);
    
    const [rows, setRows] = useState([]);
    const [allRoles, setAllRoles] = useState(['viewer', 'editor', 'admin', 'owner']);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [email, setEmail] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingScreen, setShowLoadingScreen] = useState(false);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedRoles(
            // On autofill we get a stringified value
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    // Get all users and list
    useEffect(() => {
        const getTeamUsers = async () => {
            try {
                const users = await listMembers(titleToKebab(teamsList[currentTeam]))
                console.log("Users:", users);
                const userRows = users.map((user, index) => ({
                    id: index + 1,
                    // TODO: add avatar
                    // avatar: { name: user.userName, avatar: user.avatar },
                    name: user.userName,
                    email: user.userEmail,
                    roles: user.roles || [],
                    joined: user.joined
                }));
                setRows(userRows);
            } catch (error) {
                console.error("Error fetching team users:", error);
            }
        };

        if (teamsList[currentTeam]) getTeamUsers();
    }, [currentTeam]);

    // TODO: dynamically set any existing custom roles
    // useEffect(() => {
    //     if (userSession) {
    //         getTeams(userSession.$id).then((teams) => {
    //             setAllRoles(teams);
    //         })
    //     }
    // }, [userSession]);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 0);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    if (isLoading) return <LogoLoader />;

    return (<DashboardMenu path="" user={userSession} needsOwner={true} page={userSession && (<div className="page-content">
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
            <Typography variant='p' onClick={() => navigate('/team')} sx={{ cursor: 'pointer' }}>Team</Typography>
            <Typography variant='p' onClick={() => navigate('/team/members')} sx={{ cursor: 'pointer' }}>Members</Typography>
        </Breadcrumbs>
        <Typography variant="h4" gutterBottom>
            {teamsList[currentTeam]} Members
        </Typography>
        <Box sx={{ width: '100%', mt: 3 }}>
            <DataGrid
                rows={rows}
                columns={columnsMembers}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                slots={{
                    loadingOverlay: LinearProgress,
                }}
                sx={{
                    // '& .MuiDataGrid-cell:hover': {
                    //     color: 'primary.main',
                    // },
                }}
            />
        </Box>
        <Popup
            openText="Add team member"
            openVariant="contained"
            header={"Add team member"}
            sx={{ mt: 2, maxWidth: '50%' }}
            content={<>
                <Typography variant="p" gutterBottom>
                    Send a team invitation to:
                </Typography>
                <br/>
                <TextField
                    id="email-input"
                    label="Email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                        '& .MuiInputBase-root': { height: '2.5em', overflow: 'hidden' },
                        fontSize: '0.5em',
                        width: '100%',
                        mb: 1.5
                    }}
                />
                <br/>
                <Typography variant="p" gutterBottom>
                    Set user roles <i>(optional)</i>:
                </Typography>
                <br/>
                <FormControl sx={{ width: '40vw', minWidth: '300px' }}>
                    <InputLabel id="demo-multiple-chip-label">Select roles</InputLabel>
                    <Select
                        labelId="demo-multiple-chip-label"
                        multiple
                        value={selectedRoles}
                        onChange={handleChange}
                        input={<OutlinedInput id="select-multiple-chip" label="Select teams" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                    >
                        {allRoles.map((team) => (
                            <MenuItem
                                key={team}
                                value={toTitleCase(team)}
                            >
                                {toTitleCase(team)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <br/>
                {selectedRoles.length === 0 ? <Alert variant="outlined" severity="info">
                    If no roles are specified, user will be given the <b>Editor</b> role by default.
                </Alert> :
                selectedRoles.includes('Owner') ? <Alert variant="outlined" severity="warning">
                    User will have <b>full access</b> to create and delete any team data, as well as access to <i>My Team</i> dashboard. <b>Be careful assigning this permission!</b>
                </Alert> :
                selectedRoles.includes('Admin') ? <Alert variant="outlined" severity="info">
                    User will have access to <b>create new data</b> and manage some settings. They will <b>not</b> have access to <i>My Team</i> dashboard.
                </Alert> :
                selectedRoles.includes('Editor') ? <Alert variant="outlined" severity="info">
                    User will have access to <b>edit</b> team data.
                </Alert> :
                selectedRoles.includes('Viewer') && <Alert variant="outlined" severity="info">
                    User will have <b>read-only</b> access to team data.
                </Alert>}
            </>}
            buttonSuccess={"Send invite"}
            successAction={() => {
                createInvite(titleToKebab(teamsList[currentTeam]), email, selectedRoles)
                setSnackbarOpen(true)
            }}
            successCloses={true}
            successDisabled={!email}
            buttonCancel={"Cancel"}
        />
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            autoHideDuration={6000}
            message={`Invite sent successfully! View the invite here:`}
            action={
                <a href={`/welcome/?team=${titleToKebab(teamsList[currentTeam])}&key=${token}`} target="_blank" rel="noopener noreferrer">
                Invite Link
                </a>
            }
            onClose={() => setSnackbarOpen(false)}
        />

        <Typography variant="h5" gutterBottom sx={{ mt: 6 }}>
            Pending Invites
        </Typography>
        <Box sx={{ width: '100%', mt: 3 }}>
            <DataGrid
                rows={rows}
                columns={columnsInvites}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                slots={{
                    loadingOverlay: LinearProgress,
                }}
                sx={{
                    // '& .MuiDataGrid-cell:hover': {
                    //     color: 'primary.main',
                    // },
                }}
            />
        </Box>
    </div>)} />)
}